import { initBodyPart, setBodyPart } from '@modules/bodyPart';
import { useDispatch } from '@stores';
import { IStoreBodyPart } from '@types';
import { useCallback } from 'react';

const useBodyPartActions = () => {
  const dispatch = useDispatch();

  const onInitBodyPart = useCallback(() => {
    dispatch(initBodyPart());
  }, [dispatch]);

  const onSetBodyPart = useCallback(
    (payload: IStoreBodyPart) => {
      dispatch(setBodyPart(payload));
    },
    [dispatch]
  );

  return { onInitBodyPart, onSetBodyPart };
};

export default useBodyPartActions;
